<template>
  <div>
    <template v-if="step === 1">
      <Row :gutter="8" class="m-b-20">
        <i-col span="4">
          <span class="text-red m-r-5">*</span>
          <span>选择匹配素材（可多选）</span>
        </i-col>
        <i-col span="20">
          <template v-if="source === 1">
            <Select
              v-model="fileDate"
              size="small"
              clearable
              placeholder="选择素材上传日期，筛选素材"
              style="width: 240px"
              @on-change="onChangeDate"
            >
              <Option v-for="date in fileDateArray" :key="date" :value="date">
                {{ date }}
              </Option>
            </Select>
          </template>
          <template v-else>
            <div class="m-b-10">
              <label>素材类型：</label>
              <RadioGroup
                v-model="materialType"
                type="button"
                size="small"
                @on-change="onChangeMaterialType"
              >
                <Radio
                  v-for="item in materialTypeArray"
                  :key="'m_' + item.value"
                  :label="item.value"
                  >{{ item.name }}
                </Radio>
              </RadioGroup>
            </div>
            <Row :gutter="8" class="m-b-10">
              <i-col span="6">
                <Select
                  v-model="dateQuery.materialLibrary"
                  size="small"
                  clearable
                  filterable
                  placeholder="选择素材库，可搜索"
                  @on-change="getFileDates"
                >
                  <Option
                    v-for="item in materialLibList"
                    :key="'mLib_' + item"
                    :value="item"
                    >{{ item }}</Option
                  >
                </Select>
              </i-col>
              <i-col span="6">
                <Select
                  v-model="fileDate"
                  size="small"
                  filterable
                  clearable
                  placeholder="选择画面上传日期"
                  @on-change="onChangeDate"
                >
                  <Option
                    v-for="item in fileDateArray"
                    :key="'f_' + item"
                    :value="item"
                    >{{ item }}</Option
                  >
                </Select>
              </i-col>
              <i-col span="12">
                 <Input
                size="small"
                v-model="fileQuery.keyword"
                search
                enter-button
                placeholder="可输入画面名称关键字搜索"
                @on-search="onSearchFile"
              />
              </i-col>
            </Row>
          </template>
        </i-col>
      </Row>
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          max-height: 500px;
          overflow-y: auto;
        "
      >
        <div
          style="width: 19%; margin: 0 5px 5px 5px"
          v-for="(file, index) in showFileList"
          :key="'file_' + index"
        >
          <a
            href="javascript:;"
            style="display: block"
            :class="
              selectedFiles.some((x) => x.id === file.id)
                ? 'selectedFile'
                : null
            "
            @click="handleChoiceFile(file)"
          >
            <img
              v-if="file.mimeType.includes('image')"
              :src="formatImageUrl(file.fileKey, 200, 0)"
              style="width: 100%; height: 140px; object-fit: cover"
            />
            <Card
              v-if="
                file.mimeType.includes('video') ||
                file.mimeType.includes('audio')
              "
              style="
                word-break: break-all;
                word-wrap: break-word;
                height: 80px;
                width: 100%;
              "
            >
              {{ file.fileName }} (<span class="text-orange">{{
                file.duration
              }}</span
              >秒)
            </Card>
          </a>
        </div>
        <div
          v-if="fileTotal > showFileList.length"
          style="width: 100%; text-align: center; margin-top: 10px"
        >
          <Button
            icon="ios-arrow-down"
            type="primary"
            size="small"
            @click="onloadMoreFile"
            >加载更多</Button
          >
        </div>
      </div>
      <Row :gutter="8" class="m-t-20">
        <i-col span="12">
          <span>当前已选中</span
          ><span class="text-orange p-l-5 p-r-5">{{
            selectedFiles.length
          }}</span
          ><span>项</span>
        </i-col>
        <i-col span="12" class="text-right">
          <Button
            type="primary"
            size="small"
            :disabled="selectedFiles.length === 0"
            @click="step = 2"
            >下一步</Button
          >
        </i-col>
      </Row>
    </template>
    <template v-if="step === 2">
      <Form
        :model="settingModel"
        ref="formRef"
        :rules="rulesValidate"
        label-position="top"
      >
        <FormItem label="作业日期" prop="actionDate">
          <DatePicker
            v-model="settingModel.actionDate"
            type="date"
            size="small"
            placeholder="选择作业日期"
            style="width: 200px"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <div slot="label">
            <span style="color: red; font-weight: bold; margin-right: 5px"
              >*</span
            ><span class="m-r-10">素材设定比例</span
            ><span class="text-orange"
              >提示：比例按每个站点独立分布，若站点不满足比例，下一个站点优先补充上一个站点未满足比例数</span
            >
          </div>
          <div style="display: flex; flex-wrap: wrap" class="m-t-10">
            <div
              v-for="(file, index) in selectedFiles"
              :key="'sf_' + file.id"
              style="width: 19%; margin: 0 8px 5px 0"
            >
              <img
                v-if="file.mimeType.includes('image')"
                :src="formatImageUrl(file.fileKey, 200, 0)"
                style="width: 100%; height: 140px; object-fit: cover"
              />
              <Card
                v-if="
                  file.mimeType.includes('video') ||
                  file.mimeType.includes('audio')
                "
                style="
                  word-break: break-all;
                  word-wrap: break-word;
                  height: 80px;
                  width: 100%;
                "
              >
                {{ file.fileName }} (<span class="text-orange">{{
                  file.duration
                }}</span
                >秒)
              </Card>
              <div>
                <InputNumber
                  v-model="file.ratio"
                  size="small"
                  style="width: 80%"
                /><span v-show="index < selectedFiles.length - 1" class="m-l-10"
                  >比</span
                >
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem label="相邻点位画面规则" prop="setRule">
          <RadioGroup v-model="settingModel.setRule">
            <Radio
              v-for="item in setRuleList"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <FormItem label="拍照要求（最多选两项）" prop="remarks">
          <CheckboxGroup
            class="m-b-10"
            size="small"
            v-model="settingModel.remarks"
          >
            <Checkbox
              v-for="mark in markArray"
              :key="mark.value"
              :label="mark.value"
              :disabled="
                settingModel.remarks.length > 1 &&
                !settingModel.remarks.includes(mark.value)
              "
              >{{ mark.name }}</Checkbox
            >
          </CheckboxGroup>
        </FormItem>
        <FormItem label="">
          <Input
            v-model.trim="settingModel.extras"
            size="small"
            placeholder="自定义要求"
            style="width: 100%"
          />
        </FormItem>
        <FormItem label="素材来源" prop="picturesource">
          <RadioGroup size="small" v-model="settingModel.picturesource">
            <Radio
              v-for="item in picturesourceArray"
              :key="'ps_' + item.value"
              :label="item.value"
              border
              >{{ item.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
      <Row :gutter="8" class="m-t-20">
        <i-col span="12">
          <Button type="primary" size="small" @click="step = 1">上一步</Button>
        </i-col>
        <i-col span="12" class="text-right">
          <Button type="primary" size="small" @click="onConfirmSetting"
            >确定设置</Button
          >
        </i-col>
      </Row>
    </template>
  </div>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { getPhotoDemandDictList } from '@/api/msp/dictionary'
import { agreeFile } from '@/api/order/orderfile'
import {
  agreeFileStat,
  getFileUploadDateList,
  getMaterialLibrary
} from '@/api/msp/file'
import { getFillType } from '@/api/msp/status'
export default {
  props: {
    source: {
      type: Number,
      default: 1 // 1:履约设置，2:运维设置
    },
    orderId: {
      type: Number,
      required: false
    }
    // screenFileList: {
    //   type: Array,
    //   default: new Array(0)
    // }
  },
  data () {
    return {
      step: 1,
      screenFileList: [],
      showFileList: [],
      fileDate: '',
      selectedFiles: [],
      settingModel: {
        actionDate: '',
        extras: '',
        picturesource: null,
        remarks: [],
        setRule: 1
      },
      rulesValidate: {
        actionDate: [
          {
            required: true,
            type: 'date',
            message: ' ',
            trigger: 'change'
          }
        ],
        setRule: [
          {
            required: true,
            type: 'number',
            message: ' ',
            trigger: 'change'
          }
        ],
        remarks: [
          {
            required: true,
            type: 'array',
            min: 1,
            message: ' ',
            trigger: 'change'
          },
          {
            type: 'array',
            max: 2,
            message: ' ',
            trigger: 'change'
          }
        ],
        picturesource: [
          {
            required: true,
            type: 'number',
            message: ' ',
            trigger: 'change'
          }
        ]
      },
      markArray: [],
      setRuleList: [
        { id: 1, name: '相邻随机' },
        { id: 2, name: '相邻不重复' }
      ],
      picturesourceArray: [
        { value: 1, name: '新制作' },
        { value: 2, name: '库存' },
        { value: 4, name: '不涉及制作' }
      ],
      fileDateArray: [],
      fileTotal: 0,
      fileQuery: {
        pageNumber: 1,
        pageSize: 20,
        approvalDate: '',
        approvalId: null,
        fileTypes: '1,3',
        keyword: null,
        status: 5,
        createDate: '',
        type: null,
        materialLibrary: '' // 素材库绑定值
      },
      dateQuery: {
        type: null,
        materialLibrary: '', // 素材库绑定值
        startDate: '',
        endDate: ''
      },
      materialType: 0,
      materialTypeArray: [{ value: 0, name: '全部' }],
      materialLibList: []
    }
  },
  methods: {
    show () {
      this.step = 1
      this.selectedFiles = []
      this.screenFileList = []
      this.showFileList = []
      this.materialTypeArray = [{ value: 0, name: '全部' }]
      this.getRemarkArray()
      if (this.source === 1) {
        // 履约设置
        this.getAgreeFileData()
      } else {
        this.fileQuery.pageNumber = 1
        // 运维设置
        this.getScreenTypeData()
        this.getMaterialLibData()
        this.getFileDates()
        // this.getFileData()
      }
    },
    getAgreeFileData () {
      const query = {
        pageNumber: 1,
        pageSize: 200,
        orderId: this.orderId,
        types: JSON.stringify([1, 3, 4]) // 画面、视频、音频
      }

      agreeFile(query).then((res) => {
        if (res && !res.errcode) {
          // this.allFileArray = JSON.parse(JSON.stringify(res))
          this.screenFileList = res.list
          this.showFileList = this.screenFileList

          this.screenFileList.forEach((item) => {
            if (
              this.fileDateArray.indexOf(item.createTime.substring(0, 10)) ===
              -1
            ) {
              this.fileDateArray.push(item.createTime.substring(0, 10))
            }
          })
        }
      })
    },
    getScreenTypeData () {
      getFillType().then((res) => {
        if (res && !res.errcode) {
          this.materialTypeArray = this.materialTypeArray.concat(res)
        }
      })
    },
    onChangeMaterialType () {
      const type = this.materialType === 0 ? undefined : this.materialType
      this.dateQuery.materialLibrary = ''
      this.fileDate = ''
      this.fileTotal = 0
      this.fileQuery.pageNumber = 1
      this.getMaterialLibData(type)
      this.getFileDates()
    },
    async getMaterialLibData (materialType) {
      const res = await getMaterialLibrary({ type: materialType })
      if (res && !res.errcode) {
        this.materialLibList = res
      } else {
        this.materialLibList = []
      }
    },
    /**
     * 获取素材上传时间集合
     */
    getFileDates () {
      this.fileDate = ''
      this.fileDateArray = []
      // const dateQuery = {
      //   type: null,
      //   materialLibrary: '', // 素材库绑定值
      //   startDate: '',
      //   endDate: ''
      // }
      getFileUploadDateList(this.dateQuery).then((res) => {
        if (res && !res.errcode) {
          this.fileDateArray = res
          this.onSearchFile()
        } else {
          this.fileDateArray = []
        }
      })
    },
    /**
     * 获取已通过审核的画面文件
     */
    getFileData () {
      this.fileTotal = 0
      this.fileQuery.createDate = this.fileDate || ''
      this.fileQuery.type = this.materialType === 0 ? null : this.materialType
      this.fileQuery.materialLibrary = this.dateQuery.materialLibrary
      agreeFileStat(this.fileQuery).then((res) => {
        if (res && !res.errcode) {
          this.screenFileList = this.screenFileList.concat(res.fileVOList.list)
          this.showFileList = this.screenFileList
          this.fileTotal = res.fileVOList.totalRow
          this.fileQuery.pageNumber = res.fileVOList.pageNumber
        } else {
          this.fileTotal = 0
          this.fileQuery.pageNumber = 1
        }
      })
    },
    onSearchFile () {
      this.screenFileList = []
      this.fileQuery.pageNumber = 1
      this.getFileData()
    },
    onloadMoreFile () {
      this.fileQuery.pageNumber += 1
      this.getFileData()
    },
    getRemarkArray () {
      this.markArray = []
      getPhotoDemandDictList().then((res) => {
        this.markArray = res
      })
    },
    formatImageUrl (fileUrl, width, height) {
      const widthstr = width === 0 ? '' : ',w_' + width
      const heightstr = height === 0 ? '' : ',h_' + height

      return (
        fileUrl + '?x-oss-process=image/resize,m_lfit' + widthstr + heightstr
      )
    },
    onChangeDate () {
      if (this.source === 1) {
        // 履约设置
        if (!this.fileDate) {
          this.showFileList = this.screenFileList
        } else {
          this.showFileList = this.screenFileList.filter((x) =>
            x.createTime.includes(this.fileDate)
          )
        }
      } else {
        this.screenFileList = []
        this.showFileList = []
        this.fileQuery.pageNumber = 1
        this.getFileData()
      }
    },
    handleChoiceFile (file) {
      const fileIndex = this.selectedFiles.findIndex((x) => x.id === file.id)
      if (fileIndex > -1) {
        // 选中项已存在
        this.selectedFiles.splice(fileIndex, 1)
      } else {
        const newFile = Object.assign(file, { ratio: 1 })
        this.selectedFiles.push(newFile)
      }
    },
    onConfirmSetting () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '操作提示',
            content: '确定信息无误，并提交？',
            onOk: () => {
              const fileRatios = this.selectedFiles.map((x) => {
                return {
                  fileKey: x.fileKey,
                  mimeType: x.mimeType,
                  fileId: x.id,
                  ratio: x.ratio,
                  fileName: x.fileName
                }
              })
              const remarks = this.markArray
                .filter((x) => this.settingModel.remarks.includes(x.value))
                .map((m) => m.name)
              const postData = {
                actionDate: ParseDate(this.settingModel.actionDate),
                setRule: this.settingModel.setRule,
                picturesource: this.settingModel.picturesource,
                extras: this.settingModel.extras,
                remarks: remarks.toString(),
                fileRatios: JSON.stringify(fileRatios)
              }
              this.$emit('onSave', postData)
            }
          })
        }
      })
    }
  }
  // watch: {
  //   screenFileList: {
  //     deep: true,
  //     immediate: true,
  //     handler (val) {
  //       this.showFileList = val
  //     }
  //   }
  // }
}
</script>
<style lang="less" scoped>
.selectedFile {
  border: 2px solid #ee7c4b;
}
</style>
